module.exports = __webpack_public_path__ + "img/send.259990ab.svg";